import { useAccount, useMsal } from '@azure/msal-react';

interface UserInfo {
  username: string | null;
  email: string | null;
  userRole: string | null;
  allRoles: string[];
}

/**
 * Custom hook to extract user information from Azure AD token claims
 * Returns username and user role from the ID token claims
 */
export const useUserInfo = (): UserInfo => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  if (!account) {
    return {
      username: null,
      email: null,
      userRole: null,
      allRoles: [],
    };
  }

  // Extract claims from the ID token (MSAL automatically decodes the JWT)
  const claims: any = account.idTokenClaims || {};

  // Log claims to console for debugging (remove in production)
  if (process.env.NODE_ENV === 'development') {
    console.log('User Claims from ID Token:', claims);
  }

  // Get username (display name from token)
  const username = claims.name || account.name || null;

  // Get email
  const email = claims.email || account.username || null;

  // Get user ID
  // const userId = claims.oid || account.homeAccountId || null;

  // Get user role - check multiple possible locations
  // Azure AD can return roles in different ways depending on configuration
  let rolesArray: string[] = [];
  const rolesData =
    claims.roles || // Standard roles claim (array)
    claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || // SAML format
    claims['extension_Roles'] || // Custom extension attribute
    claims['extension_roles'] || // Custom extension attribute (lowercase)
    null;

  // Ensure we always have an array of roles
  if (Array.isArray(rolesData)) {
    rolesArray = rolesData;
  } else if (rolesData) {
    rolesArray = [rolesData];
  }

  return {
    username,
    email,
    // userId,
    userRole: rolesArray.length > 0 ? rolesArray[0] : null, // Return first role
    allRoles: rolesArray, // All roles as array
    // rawClaims: claims, // Raw claims for debugging
  };
};
